import React, { useState, useEffect } from 'react';
import './Footer.css';
import { Link } from 'react-router-dom';

export default function Footer() {
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const baseUrl = process.env.REACT_APP_BASE_URL || '';

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');
    try {
      const res = await fetch(`${baseUrl}/api/contact`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(form),
      });
      const data = await res.json();
      if (res.ok) {
        setSuccess(data.message || 'הפנייה נשלחה!');
        setForm({ name: '', email: '', message: '' });
      } else {
        setError(data.error || 'שגיאה בשליחת הפנייה');
      }
    } catch (err) {
      setError('שגיאה בשליחת הפנייה');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (success || error) {
      const timer = setTimeout(() => {
        setSuccess('');
        setError('');
      }, 2000);
      return () => clearTimeout(timer);
    }
  }, [success, error]);

  return (
    <footer className="footer-main" id="contact-footer">
      <div className="footer-content">
        {/* Right: Links */}
        <div className="footer-links">
          <Link to="/programs">כל התוכניות</Link>
          <Link to="/minites">המיניטס</Link>
          <Link to="/branding">המיתוגים</Link>
          <Link to="/profile">אזור אישי</Link>
        </div>
        {/* Center: Contact Info */}
        <div className="footer-center">
          <div className="footer-title">ככה יוצרים איתנו קשר:</div>
          <div className="footer-email">cazoty.min.tochnit@gmail.com</div>
          <div className="footer-phone">053.4123.358</div>
          <div className="footer-phone">054.8539.868</div>
        </div>
        {/* Left: Contact Form */}
        <form className="footer-form" onSubmit={handleSubmit}>
          <div className="footer-form-row">
            <input
              type="text"
              name="name"
              placeholder="שם:"
              value={form.name}
              onChange={handleChange}
              className="footer-input"
              required
            />
            <input
              type="email"
              name="email"
              placeholder="אימייל:"
              value={form.email}
              onChange={handleChange}
              className="footer-input"
              required
            />
          </div>
          <textarea
            name="message"
            placeholder="תוכן הפנייה:"
            value={form.message}
            onChange={handleChange}
            className="footer-textarea"
            required
          />
          <div className="footer-form-actions">
            <div className="footer-form-messages">
              {success && <div className="footer-success-msg">{success}</div>}
              {error && <div className="footer-error-msg">{error}</div>}
            </div>
            <button type="submit" className="footer-send-btn" disabled={loading}>
              {loading ? 'שולח...' : 'שלח'}
            </button>
          </div>
        </form>
      </div>
    </footer>
  );
}
